<template>

	<div ref="invoiceForm" id="invoice-form">
	<div class="row">
		<div class="col-xs-12">
			<a :href="backLinkUrl">{{ backLinkText }}</a>
		</div>
	</div>

	<h1 class="page-header">
		New Invoice
		<button type="submit" class="btn btn-primary pull-right" v-on:click="saveNewInvoice()">Save New Invoice</button>
	</h1>

	<div class="row">
		<div class="col-xs-12">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<span class="h4">Members and Squads to Invoice</span>
				</div>
				<div class="panel-body">
				<div class="col-xs-12">
					<div class="form-group">
						<label for="member_id" class="control-label">Members To Invoice:&nbsp;<span class="glyphicon glyphicon-question-sign" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="The invoice will be raised for all members you select."></span></label>
						<select2 :options="memberSelect2Options" v-model="invoice.member_id" :multiple="true" />
						<p class="small text-danger" v-if="errors && errors.member_id" v-for="error in errors.member_id">{{ error }}</p>
					</div>
				</div>
				<div class="col-xs-12">
					<div class="form-group">
						<label for="squad_id" class="control-label">Squads To Invoice:&nbsp;<span class="glyphicon glyphicon-question-sign" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="The invoice will be raised for all members in the squads you select."></span></label>
						<select2 :options="squadSelect2Options" v-model="invoice.squad_id" :multiple="true" />
						<p class="small text-danger" v-if="errors && errors.squad_id" v-for="error in errors.squad_id">{{ error }}</p>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>


	<div class="row">
		<div class="col-xs-12">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<span class="h4">Invoice Items</span>
				</div>
			<table class="table table-striped table-bordered">
				<thead>
				<tr>
					<th>&nbsp;</th>
					<th class="col-xs-6">Item</th>
					<th class="col-xs-3">Revenue Account</th>
					<th class="col-xs-3">Amount</th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(lineItem, lineItemIdx) in invoice.line_items">
					<td class="text-center line-item-number">{{ lineItemIdx+1 }}</td>
					<td>
						<input type="text" v-model="lineItem.description" class="form-control line-item-description"/>
						<p class="small text-danger" v-if="errors && errors[`line_items.${lineItemIdx}.description`]" v-for="error in errors[`line_items.${lineItemIdx}.description`]">{{ error }}</p>
					</td>
					<td>
						<div class="line-item-revenue-account">
						<select2 v-model="lineItem.financial_account_id" :options="financialAccountSelect2Options" />
							<p class="small text-danger" v-if="errors && errors[`line_items.${lineItemIdx}.financial_account_id`]" v-for="error in errors[`line_items.${lineItemIdx}.financial_account_id`]">{{ error }}</p>
						</div>
					</td>
					<td>
						<div class="line-item-amount">
						<div class="input-group">
							<span class="input-group-addon">£</span>
							<input type="text" v-model="lineItem.value" class="form-control" />
						</div>
							<p class="small text-danger" v-if="errors && errors[`line_items.${lineItemIdx}.value`]" v-for="error in errors[`line_items.${lineItemIdx}.value`]">{{ error }}</p>
						</div>
					</td>
					<td>
						<button class="btn btn-danger btn-sm" @click="removeLineItem(lineItemIdx)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
					</td>
					
				</tr>
				</tbody>
			</table>
				<div class="panel-footer">
					<div class="row">
					<div class="col-xs-12">
					<button class="btn btn-primary pull-right" @click="addLineItem()">Add Line</button>
					</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
	
</template>

<style scoped>
</style>
<script>
import { Message, Loading } from 'element-ui';

export default {
	props: {
		memberOptions: {
			type: Array,
			default: []
		},
		squadOptions: {
			type: Array,
			default: []
		},
		financialAccountOptions: {
			type: Array,
			default: []
		},
		backLinkText: {
			type: String|null,
			default: null
		},
		backLinkUrl: {
			type: String|null,
			default: null
		}
	},
	data: function () {
		return {
			invoice: {
				member_id: [],
				squad_id: [],
				line_items: [{
					description: '',
					financial_account_id: null,
					value: null,
				}]
			},
			errors: {},
			saving: false,
			loading: null
		}
	},
	computed: {
		financialAccountSelect2Options: function() {
			return this.financialAccountOptions.map((item) => {
				return {
					id: item.id,
					text: item.name
				}
			})
		},
		memberSelect2Options: function() {
			return this.memberOptions.map((item) => { 
				return { id: item.id, text: item.full_name }
			});
		},
		squadSelect2Options: function() {
			return this.squadOptions.map((item) => {
				return { id: item.id, text: item.name }
			});
		},
	},
	mounted() {
		console.log('New Invoice page mounted.');
	},
	methods: {
		saveNewInvoice() {
			if (this.saving === true) {
				this.$message({message: 'Please wait.', type: 'error'});
				return;
			}
			this.errors = [];
			this.saving = true;
			this.loading = this.$loading({
				target: '#invoice-form'
			});
			console.log('saveNewInvoice');
			console.log(JSON.stringify(this.invoice))
			axios.post('/api/v1/invoices', this.invoice)
				.then((response) => { 
					console.log(response.data)
					this.resetForm();
					this.$message({message: 'Your invoices have been created.', type: 'success'});
					
					window.location.href='/club/invoices';
				})
				.catch((error) => {
					console.error(error.response)
					this.errors = error.response.data.errors;
				})
				.finally(() => {
					this.saving = false;
					this.loading.close();
				});
		},
		addLineItem() {
			this.invoice.line_items.push({
				description: '',
				financial_account_id: null,
				value: null,
			})
		},
		removeLineItem(lineItemIndex) {
			this.invoice.line_items.splice(lineItemIndex, 1)
		},
		resetForm() {
			this.invoice = {
				member_id: [],
				squad_id: [],
				line_items: [{
					description: '',
					financial_account_id: null,
					value: null,
				}]
			}
		},
		debug(message) {
			console.log('NewInvoice: ' + message);
		},
	}
}
</script>
